export default __webpack_public_path__ + "static/media/rndpage3-2.b0c5038b.png";